module.exports = __webpack_public_path__ + "static/media/Hamburger.79b18a5d.png";